import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Calender from "./Input-Calender";
import Guests from "./Input-guests";
import GuestsHover from "./Input-guests-hover";
import { Link } from "react-router-dom";
import DateCalender from "./about";
import InputBox from "./Input-box";
import axios from "axios";
const data = [
  {
    id: 2,
    name: "Goa",
  },
  {
    id: 29,
    name: "Kodaikanal",
  },
  {
    id: 21,
    name: "Dhanaulti",
  },
  {
    id: 22,
    name: "Mount Abu",
  },
  {
    id: 3,
    name: "Lonavala",
  },
  {
    id: 4,
    name: "Manali",
  },
  {
    id: 6,
    name: "Khopoli",
  },
  {
    id: 7,
    name: "Mahabaleshwar",
  },
  {
    id: 8,
    name: "Panchgani",
  },
  {
    id: 9,
    name: "Alibag",
  },
  {
    id: 10,
    name: "Pune",
  },
  {
    id: 11,
    name: "Udaipur",
  },
  {
    id: 12,
    name: "Indore",
  },
  {
    id: 13,
    name: "Madikeri",
  },
  {
    id: 14,
    name: "Nashik",
  },
  {
    id: 30,
    name: "Ooty",
  },
  {
    id: 15,
    name: "Neemuch",
  },
  {
    id: 16,
    name: "Palgarh",
  },
  {
    id: 17,
    name: "Uttan",
  },
  {
    id: 24,
    name: "Kasauli",
  },
  {
    id: 20,
    name: "Kamshet",
  },
  {
    id: 25,
    name: "Jaipur",
  },
  {
    id: 31,
    name: "Bengaluru",
  },
  {
    id: 18,
    name: "Mussoorie",
  },
  {
    id: 26,
    name: "Dehradun",
  },
  {
    id: 27,
    name: "Shimla",
  },
  {
    id: 19,
    name: "Raipur",
  },
  {
    id: 23,
    name: "Kanatal",
  },
  {
    id: 5,
    name: "Karjat",
  },
  {
    id: 28,
    name: "Lansdowne",
  },
  {
    id: 1,
    name: "Igatpuri",
  },
];

const Input = () => {
  const navigate = useNavigate();

  const [cities, setCities] = useState();

  const handleSelection = async () => {
    const res2 = await axios.get(`http://localhost:8000/api/v1//getAllCities`);
     setCities(res2.data.data)
    // setCities(data);
    // //console.log(res2.data.data);
  };
  useEffect(() => {
    handleSelection();
  }, []);

  //State Functioms
  const [value, setValue] = useState();
  const [input, setinput] = useState("");
  const [selector, setSelector] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [location, setLocation] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  ////
  //handle Functions
  const handleValueChange = (newValue) => {
    //console.log("newValue:", newValue);
    setValue(newValue);
  };

  const handleAdults = (v) => {
    setAdults((prev) => {
      let x = prev + v;
      if (x < 1) {
        return 1;
      } else {
        return x;
      }
    });
  };
  const handleChildren = (v) => {
    setChildren((prev) => {
      let x = prev + v;
      if (x < 0) {
        return 0;
      } else {
        return x;
      }
    });
  };

  const handleSelector = () => {
    setSelector(!selector);
  };

  // const handleInputChange = (e) => {
  //   setinput(e.target.value);
  //   //console.log(input);
  // };

  // This is sending the data to other components
  const handleSubmit = () => {
    const formData = {
      location: location,
      startDate: startDate,
      endDate: endDate,
      adults: adults,
      children: children,
    };
    const hyphenlocation = location.replace(' ', '-');
    navigate(`/search/${hyphenlocation}`, { state: formData });
  };

  ////
  return (
    <div className="relative font-hk flex flex-col md:flex-row justify-center mx-4 md:mx-auto">
  <div className="bg-opacity-[1] md:bg-opacity-90 bg-[#f0ede8] md:bg-white text-black md:border-[#7b6c6c] rounded-3xl md:rounded-full md:border-0 lg:rounded-full md:py-1 lg:py-2 items-center flex flex-col md:flex-row md:flex-wrap md:justify-between md:w-[80vw] lg:w-[70vw] shadow-3xl md:shadow-xl md:mt-[-63vh] lg:-mt-[71.1vh] md:z-20 relative md:absolute">
    <div className="flex flex-row lg:ml-[20px] w-full md:w-1/4 justify-center md:justify-between md:my-2">
      <img
        src="/Map.svg"
        className="hidden md:flex scale-[0.85] lg:px-4"
      ></img>
      <div className="flex flex-col md:mt-2">
        <div className="absolute z-[1000] left-[70px]">
          <InputBox
            inputbox={location}
            setInputBox={setLocation}
            cities={cities}
          />
        </div>
      </div>
    </div>

    <div className="w-full md:w-1/4 md:flex justify-center md:my-2">
      <DateCalender
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
    </div>

    <div className="md:ml-2 flex flex-col mt-0 md:mt-2 w-full md:w-1/4 justify-center my-2">
      <div className="justify-center">
        <Guests
          children={children}
          adults={adults}
          handleSelector={handleSelector}
        />
      </div>
    </div>
    <div className="md:ml-[20px] md:mr-8 content-end">
      <button
        onClick={() => {
          handleSubmit();
        }}
        className="flex md:hidden w-[80vw] h-[7vh] my-5 mx-5 md:mx-0 md:my-0 md:w-auto md:h-auto justify-center bg-[#000000]"
      >
      </button>
      <img
        onClick={() => {
          handleSubmit();
        }}
        src="/Search.svg"
        className="hidden md:flex scale-[0.75]"
      ></img>
    </div>
  </div>
  <GuestsHover
    children={children}
    adults={adults}
    handleSelector={handleSelector}
    selector={selector}
    handleAdults={handleAdults}
    handleChildren={handleChildren}
  />
</div>

  );
};

export default Input;
